import type { QuestionnaireFieldOptionRequest, QuestionnaireForm, QuestionnaireFormField, QuestionnaireFormFieldRequest, QuestionnaireFormRequest, QuestionnaireFormResponse } from '@/types/questionnaire';

export const transformQuestionnaireDetail = (data: QuestionnaireFormResponse): QuestionnaireForm => {
	const fields = data.fields.map((field): QuestionnaireFormField => {
		const validation = field.validation?.split('|');
		const isRequired = validation?.includes('required') || false;

		const options = field.options?.map((option) => {
			return {
				...option,
				label: option.value, // Lack label field in API
			};
		});

		return {
			id: field.id,
			type: field.type || FORM_TYPE.TEXT, // Set default to text
			label: field.label,
			isRequired,
			options,
		};
	});
	return {
		id: data.id,
		name: data.name,
		status: data.status,
		createdDate: convertDateTimeFromUtcToTimezone(data.created.utc, data.created.timezone, DATE_PICKER_FORMAT),
		isEnableForm: false,
		fields,
	};
};

export const transformQuestionnaireList = (dataItems: Array<QuestionnaireFormResponse>): Array<QuestionnaireForm> => dataItems.map(transformQuestionnaireDetail);

export const generateQuestionnaireFormPayload = (data: QuestionnaireForm): QuestionnaireFormRequest => {
	const fields = data?.fields?.map((field: QuestionnaireFormField, index: number): QuestionnaireFormFieldRequest => {
		const options: QuestionnaireFieldOptionRequest[] = [];

		field?.options?.forEach((option, optionIndex) => {
			if (option.value) {
				options.push({
					/*
						- To `add` an option, set id property value with a string value begins with new keyword
						  The values should be unique among options under the same field.
						- To `update` a option, change the values of properties but keep the value of `id` property unchanged.
					*/
					id: option.id ?? optionIndex + 1,
					label: option.value,
					value: option.value,
				});
			}
		});
		return {
			/*
				- To `add` a field, set id property value with a string value begins with new keyword.
				Id should be unique among the fields, the new keyword appended with the UNIX timestamp is recommended when generating the IDs.
				- To `update` a field, change the values of properties but keep the value of `id` property unchanged.
			*/
			id: field.id === -1 ? `new${Date.now() + index}` : field.id,
			type: field.type || FORM_TYPE.TEXT, // Set default to text
			label: field.label,
			validation: field.isRequired ? 'required' : '',
			options,
		};
	});
	return {
		// Not send "id" if it's new form. Create new form will have default id as -1
		...(data.id === -1 ? {} : {
			id: data.id,
		}),
		name: data?.name,
		fields,
	};
};

